/**
 * Load Newsletter form dynamically
 */

export default class NewsletterChunk {
  static body: HTMLElement;

  static styleCreated = false;

  static loadScript = false;

  static preconnect = false;

  constructor() {
    NewsletterChunk.body = document.querySelector('body');
    const newsletterInput: HTMLInputElement = document.querySelector(
      '#c-newsletter__email'
    );

    /* Load Newsletter to click in field */
    if (newsletterInput) {
      newsletterInput.addEventListener('click', (event) => {
        this.importNewsletterClick(event);
      });
    }
  }

  /**
   * Load Newsletter to click
   *
   * @param {Event} event - Click event
   */
  importNewsletterClick = (event: Event) => {
    event.preventDefault();

    if (!NewsletterChunk.body.classList.contains('import-newsletter-js')) {
      import(
        /* webpackPrefetch: true */ /* webpackChunkName: 'prefetch-NewsletterLoadScript' */ '../../../components/Newsletter/Newsletter'
      ).then(({ default: Newsletter }) => {
        new Newsletter();
        NewsletterChunk.body.classList.add('import-newsletter-js');
      });
    }
  };
}
